import ActiveTabsTypes from './active-tab.types';

const initialState = {
  activeTab: 'home',
  showModal: false,
  modalAction: null,
};

const activeTabReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActiveTabsTypes.SET_ACTIVE_TAB:
      return { ...state, activeTab: action.payload };
    case ActiveTabsTypes.REMOVE_ACTIVE_TAB:
      return { ...state, activeTab: 'home' };
    case ActiveTabsTypes.SHOW_MODAL:
      return { ...state, showModal: action.payload };
    case ActiveTabsTypes.MODAL_ACTION:
      return { ...state, modalAction: action.payload };
    default:
      return state;
  }
};

export default activeTabReducer;
